import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { Input as AIMEInput } from "tot-loft-component-library";
import GenericModal from "./GenericModal";
import ModalProfileinfoone from "./ModalProfileinfoone";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useInputor } from "react-redux";
import {
  fetchVendorById,
  updateVendorsonhome,
  uploadImage,
} from "./redux/slices/VendorThunks";
import { isValidURL } from "./utils";
import PhoneInputField from "./prtnr/ui/PhoneInput";

function GeneralSettings({ vendor }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Modal logic goes here for Profileinfoone
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [editVendorState, setEditVendorState] = useState(vendor);
  const oldState = vendor;
  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const [workEmailError, setWorkEmailError] = useState("");
  const [websiteError, setwebsiteError] = useState("");

  const handleFieldChange = async (key, value) => {
    try {
      const res = await dispatch(uploadImage(value));
      setEditVendorState((prev) => ({
        ...prev,
        [key]: res.payload.fileURL,
      }));
    } catch (e) {
      console.log(e, "error");
    }
  };
  const handleUpdate = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    if (!emailRegex.test(editVendorState?.vendor_work_email)) {
      setWorkEmailError("Invalid email. Please enter a valid email address.");
      return;
    }

    const url = editVendorState?.company_website_url;

    if (isValidURL(url)) {
      const { _id, ...payloadWithoutId } = editVendorState; // 🔥 Remove _id

      await dispatch(updateVendorsonhome(payloadWithoutId));
      await dispatch(fetchVendorById(user?._id));
      openModal();
    } else {
      setwebsiteError(
        "Invalid website. Please enter a valid URL with a recognized domain like .com .uk etc"
      );
    }
  };

  return (
    <Frame1501>
      <Frame1496>
        <GeneralInformation>General Information</GeneralInformation>
        <VednorFourm>
          <Frame1502>
            <PRTNR.Input
              label="First Name"
              
              value={editVendorState?.vendor_firstname}
              // onChange={(e) => {
              //   setEditVendorState({
              //     ...editVendorState,
              //     vendor_firstname: e.target.value,
              //   });
              // }}
            />

            <PRTNR.Input
              label="Last Name"
              
              value={editVendorState?.vendor_lastname}
              // onChange={(e) => {
              //   setEditVendorState({
              //     ...editVendorState,
              //     vendor_lastname: e.target.value,
              //   });
              // }}
            />
          </Frame1502>

          <PhoneInputField
            label="Phone"
            name={"phone_number"}
            value={editVendorState.contact_number}
            // onChange={(val) => {
            //   setEditVendorState({
            //     ...editVendorState,
            //     contact_number: val,
            //   });
            // }}
            
          />

          <PRTNR.Input
            label="Work email address"
            value={editVendorState?.vendor_work_email}
            // onChange={(e) => {
            //   setEditVendorState({
            //     ...editVendorState,
            //     vendor_work_email: e.target.value,
            //   });
            // }}
            
            error={!!workEmailError}
            errorMessage={workEmailError}
          />

          <Frame1406>
            <VendorInformation>Vendor Information</VendorInformation>
            <Frame1407>
              <PRTNR.Input
                label="Company name"
                value={editVendorState?.company_name}
                // onChange={(e) => {
                //   setEditVendorState({
                //     ...editVendorState,
                //     company_name: e.target.value,
                //   });
                // }}
                
              />

              <PRTNR.FileInput
                label="Company Logo"
                helpText="JPG, GIF or PNG. Max file size 800kb"
                accept=".jpg,.jpeg,.gif,.png"
                // onChange={(e) => {
                //   if (e) {
                //     handleFieldChange("compay_logo", e);
                //   } else {
                //     console.log("No file Inputed");
                //   }
                // }}
                name="profile_picture"
                value={editVendorState?.compay_logo}
                
              />

              <PRTNR.Input
                label="Company Website"
                value={editVendorState?.company_website_url}
                // onChange={(e) => {
                //   setEditVendorState({
                //     ...editVendorState,
                //     company_website_url: e.target.value,
                //   });
                // }}
                
                error={!!websiteError}
                errorMessage={websiteError}
              />

              <PRTNR.FileInput
                label="Website Thumbnail"
                helpText="JPG, GIF or PNG. Max file size 800kb"
                accept=".jpg,.jpeg,.gif,.png"
                // onChange={(e) => {
                //   if (e) {
                //     handleFieldChange("website_thumbnail", e);
                //   } else {
                //     console.log("No file Inputed");
                //   }
                // }}
                name="website_thumbnail"
                value={editVendorState?.website_thumbnail}
                
              />
              <Frame1518>
                <PRTNR.Input
                  label="Year founded"
                  type="text"
                  
                  pattern="\d{4}"
                  maxLength={4}
                  value={editVendorState?.year_founded}
                  // onChange={(e) => {
                  //   setEditVendorState({
                  //     ...editVendorState,
                  //     year_founded: e.target.value,
                  //   });
                  // }}
                />

                <PRTNR.Input
                  label="Vendor HQ"
                  value={editVendorState?.vendor_hq}
                  // onChange={(e) => {
                  //   setEditVendorState({
                  //     ...editVendorState,
                  //     vendor_hq: e.target.value,
                  //   });
                  // }}
                />
              </Frame1518>
              <Frame1518>
                <PRTNR.Input
                  label="Number of employees"
                  // options={[
                  //   { value: "0-1", label: "0-1 employees" },
                  //   { value: "2-10", label: "2-10 employees" },
                  //   { value: "11-50", label: "11-50 employees" },
                  //   { value: "51-200", label: "51-200 employees" },
                  //   { value: "201-500", label: "201-500 employees" },
                  //   { value: "501-1000", label: "50U+20131000 employees" },
                  //   { value: "1001-5000", label: "1001–5000 employees" },
                  //   { value: "5001-10000", label: "5001–10000 employees" },
                  //   { value: "10001+", label: "10001+ employees" },
                  // ]}
                  value={editVendorState?.no_of_employees}
                  // onChange={(e) => {
                  //   setEditVendorState({
                  //     ...editVendorState,
                  //     no_of_employees: e.target.value,
                  //   });
                  // }}
                />
              </Frame1518>
            </Frame1407>
          </Frame1406>
          <Frame1406>
            <IdealClientProfile>Ideal Client Profile</IdealClientProfile>
            <Frame1407>
              <PRTNR.Input
                label="Summary"
                value={editVendorState?.ideal_profile}
                // onChange={(e) => {
                //   setEditVendorState({
                //     ...editVendorState,
                //     ideal_profile: e.target.value,
                //   });
                // }}
              />
              <PRTNR.Input
                label="Typical Sector"
                value={editVendorState?.sector}
                // options={[
                //   { value: "Martech", label: "Martech" },
                //   { value: "Marketing Activity", label: "Marketing Activity" },
                //   { value: "Data & Insight", label: "Data & Insight" },
                //   { value: "Talent Development", label: "Talent Development" },
                //   { value: "Corporate Services", label: "Corporate Services" },
                //   {
                //     value: "Information Technology",
                //     label: "Information Technology",
                //   },
                // ]}
                // onChange={(e) => {
                //   setEditVendorState({
                //     ...editVendorState,
                //     sector: e.target.value,
                //   });
                // }}
                
              />

              <Frame1518>
                <PRTNR.Input
                  label="Typical Company Size"
                  // options={[
                  //   { value: "0-1 employees", label: "0-1 employees" },
                  //   { value: "2-10 employees", label: "2-10 employees" },
                  //   { value: "11-50 employees", label: "11-50 employees" },
                  //   { value: "51-200 employees", label: "51-200 employees" },
                  //   { value: "201-500 employees", label: "201-500 employees" },
                  //   {
                  //     value: "501-1000 employees",
                  //     label: "501-1000 employees",
                  //   },
                  //   {
                  //     value: "1001-5000 employees",
                  //     label: "1001-5000 employees",
                  //   },
                  //   {
                  //     value: "5001-10000 employees",
                  //     label: "5001-10000 employees",
                  //   },
                  //   { value: "10001+ employees", label: "10001+ employees" },
                  // ]}
                  value={editVendorState?.company_size}
                  // onChange={(e) => {
                  //   setEditVendorState({
                  //     ...editVendorState,
                  //     company_size: e.target.value,
                  //   });
                  // }}
                  
                />

                <PRTNR.Input
                  label="Typical Location"
                  // options={[
                  //   { value: "uk", label: "UK" },
                  //   { value: "usa", label: "USA" },
                  //   { value: "global", label: "Global" },
                  //   { value: "emea", label: "EMEA" },
                  //   { value: "americas", label: "Americas" },
                  //   { value: "apac", label: "APAC" },
                  // ]}
                  value={editVendorState?.locations}
                  // onChange={(e) => {
                  //   setEditVendorState({
                  //     ...editVendorState,
                  //     locations: e.target.value,
                  //   });
                  // }}
                  
                />
              </Frame1518>

              <PRTNR.Input
                label="Typical Client Budget"
                // options={[
                //   { value: "0-5000", label: "£0–£5000" },
                //   { value: "5001-10000", label: "£5001–£10000" },
                //   { value: "10001-15000", label: "£10001–£15000" },
                //   { value: "15001-25000", label: "£15001–£25000" },
                //   { value: "25001-50000", label: "£25001–£50000" },
                //   { value: "50001-100000", label: "£50001–£100000" },
                //   { value: "100001+", label: "£100000+" },
                // ]}
                value={editVendorState?.typical_budget}
                // onChange={(e) => {
                //   setEditVendorState({
                //     ...editVendorState,
                //     typical_budget: e.target.value,
                //   });
                // }}
                
              />

              <PRTNR.Input
                label="Typical Decision Maker"
                value={editVendorState?.typical_decision_maker}
                // onChange={(e) => {
                //   setEditVendorState({
                //     ...editVendorState,
                //     typical_decision_maker: e.target.value,
                //   });
                // }}
                
              />

              <PRTNR.Input
                label="Typical Scenario"
                value={editVendorState?.typical_scenario}
                // onChange={(e) => {
                //   setEditVendorState({
                //     ...editVendorState,
                //     typical_scenario: e.target.value,
                //   });
                // }}
                
              />

              <PRTNR.Input
                label="Typical Pain Points"
                value={editVendorState?.typical_pain_points}
                // onChange={(e) => {
                //   setEditVendorState({
                //     ...editVendorState,
                //     typical_pain_points: e.target.value,
                //   });
                // }}
                
              />

              <PRTNR.Input
                label="Typical Deal Cycle"
                // options={[
                //   { value: "1 - 30 days", label: "1 - 30 days" },
                //   { value: "31 - 90 days", label: "31 - 90 days" },
                //   { value: "91 - 180 days", label: "91 - 180 days" },
                //   { value: "181+ days", label: "181+ days" },
                // ]}
                value={editVendorState?.average_sales_cycle_in_months}
                // onChange={(e) => {
                //   setEditVendorState({
                //     ...editVendorState,
                //     average_sales_cycle_in_months: e.target.value,
                //   });
                // }}
                
              />
            </Frame1407>
          </Frame1406>
        </VednorFourm>
      </Frame1496>
      <Frame1501_0001>
        <About>About</About>
        <PRTNR.TextArea
          label="About"
          value={editVendorState?.about}
          // onChange={(e) => {
          //   setEditVendorState({ ...editVendorState, about: e.target.value });
          // }}
        />
      </Frame1501_0001>
      <Frame1502_0001>
        <VendorMessageToMembers>
          Vendor Message to Members
        </VendorMessageToMembers>

        <PRTNR.TextArea
          label="Message"
          value={editVendorState?.message}
          // onChange={(e) => {
          //   setEditVendorState({ ...editVendorState, message: e.target.value });
          // }}
        />
        <Frame1502>
          <div style={{ width: "100%" }}>
            <PRTNR.Input
              label="Stakeholder name"
              value={editVendorState?.ceo_name}
              // onChange={(e) => {
              //   setEditVendorState({
              //     ...editVendorState,
              //     ceo_name: e.target.value,
              //   });
              // }}
            />
          </div>
          <div style={{ width: "100%" }}>
            <PRTNR.FileInput
              label="Stakeholder picture "
              helpText="JPG, GIF or PNG. Max file size 800kb"
              accept=".jpg,.jpeg,.gif,.png"
              value={
                editVendorState.picture
                  ? editVendorState.picture.split("/").pop()
                  : ""
              }
              // onChange={(e) => {
              //   if (e) {
              //     handleFieldChange("picture", e);
              //   } else {
              //     console.log("No file Inputed");
              //   }
              // }}
              name="profile_picture"
            />
          </div>
        </Frame1502>
      </Frame1502_0001>
      {/* <Frame1503_0001>
        <TermsConditions>Terms & Conditions</TermsConditions>

        <PRTNR.TextArea
          label="Terms & Conditions"
          value={editVendorState?.terms_and_conditions}
          onChange={(e) => {
            setEditVendorState({
              ...editVendorState,
              terms_and_conditions: e.target.value,
            });
          }}
        />
      </Frame1503_0001> */}
      {/* <Frame1500>
        <PRTNR.Button variant="gray-light" onClick={() => navigate("/")}>
          Cancel
        </PRTNR.Button>

        <Frame1399>
          <PRTNR.Button
            variant="black"
            onClick={() => {
              handleUpdate();
            }}
          >
            Submit
          </PRTNR.Button>
        </Frame1399>
      </Frame1500> */}

      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalProfileinfoone isOpen={isModalOpen} onClose={closeModal} />
      </GenericModal>
    </Frame1501>
  );
}

export default GeneralSettings;

const Frame1501 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-end;
  flex: 1;
  gap: 21px;
  width: 886px;
  box-sizing: border-box;
`;

const Frame1496 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border: solid 1px rgb(225, 228, 233);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const GeneralInformation = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
`;

const VednorFourm = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1502 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const PrtnrInput = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  width: 419px;
  box-sizing: border-box;
`;

const GFieldsStacked = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame8 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const FieldLabel = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const NaN_0001 = styled.span`
  color: rgb(223, 63, 63);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  letter-spacing: 2px;
  line-height: 16px;
  text-align: left;
  text-transform: uppercase;
`;

const Field = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border: solid 1px rgb(224, 228, 244);
  border-radius: 8px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px 16px;
  flex-shrink: 0;
`;

const Placeholder = styled.span`
  color: rgb(74, 21, 75);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 387px;
  flex: 1;
`;

const PrtnrInput_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Placeholder_0002 = styled.span`
  color: rgb(74, 21, 75);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 824px;
  flex: 1;
`;

const Frame1406 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 16px 0px 0px;
  flex-shrink: 0;
`;

const VendorInformation = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1407 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Placeholder_0004 = styled.span`
  color: rgb(74, 21, 75);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 823px;
  flex: 1;
`;

const PrtnrFileInput = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Placeholder_0005 = styled.span`
  color: rgb(74, 21, 75);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 822px;
  flex: 1;
`;

const PrtnrButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  border-radius: 8px;
  width: 109px;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px 24px;
`;

const Label = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Inter, sans-serif;
  font-weight: 600;
  line-height: 125%;
  text-align: left;
`;

const Frame1518 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;



const Frame5 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const FieldLabel_0008 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Placeholder_0008 = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 374px;
  flex: 1;
`;

const IconCaretdown = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const CaretDown = styled.div`
  width: 9px;
  height: 5px;
  background: url(https://s3-alpha-sig.figma.com/img/46bf/ca2f/25eedd208bc5c58011128405095de699?Expires=1749427200&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=TI2quGmm0PogRcGZ5Ijn0sZ1wQvgIqfLM607VoItwHpXkWA3z7dsydcUFmLWtPem42EciVHHw-Q6522f3Xn4WY-PUgbcQHq-s3cYw2OzCHDbAAyrOpWCAk0JfPLeLA9NgugV8t7nqeZ7gJtu-WaccbThFtv54ZtwAt0Ma-22~olee3IvaGlWue9n~H9i5OMRpUVVBANZt4RTdi22GNhIfvP-DMsU7bL9ai~GF59xW1qlXZ7G4rgh94CQdelXf5iVzBh7I3z6NIlTfRMId46-Ayc~nDWViPOJamuEAQkMkK9rhUEGI1K6~HrChdAhRAbG3J~62X8mxmvOvsp6d3af7w__);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const PrtnrInput_0006 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  width: 423px;
  box-sizing: border-box;
`;

const Placeholder_0009 = styled.span`
  color: rgb(74, 21, 75);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 393px;
  flex: 1;
`;

const PrtnrInput_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  width: 854px;
  box-sizing: border-box;
`;

const Placeholder_0010 = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 807px;
  flex: 1;
`;

const IdealClientProfile = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Placeholder_0012 = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 376px;
  flex: 1;
`;

const PrtnrInput_0004 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1501_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border: solid 1px rgb(225, 228, 233);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const About = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
`;

const PrtnrTextarea = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  height: 188px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const GFieldsStacked_0019 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  align-self: stretch;
  height: 188px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Field_0019 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  border: solid 1px rgb(224, 228, 244);
  border-radius: 8px;
  align-self: stretch;
  height: 162px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px 16px;
  flex-shrink: 0;
`;

const Frame1502_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border: solid 1px rgb(225, 228, 233);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const VendorMessageToMembers = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
`;

const PrtnrInput_0011 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  width: 419px;
  height: 68px;
  box-sizing: border-box;
`;

const Placeholder_0021 = styled.span`
  color: rgb(74, 21, 75);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 388px;
  flex: 1;
`;

const PrtnrFileInput_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  width: 419px;
  box-sizing: border-box;
`;

const Frame1503_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border: solid 1px rgb(225, 228, 233);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const TermsConditions = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
`;

const Frame1500 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 17px;
  box-sizing: border-box;
`;

const PrtnrButton_0003 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  flex: none;
  border-radius: 999px;
  width: 165px;
  background: rgb(226, 232, 240);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px 32px;
`;

const Label_0003 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 110%;
  text-align: left;
`;

const Frame1399 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 16px;
  box-sizing: border-box;
  min-width: 250px;
`;

const PrtnrButton_0004 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  flex: 1;
  border-radius: 999px;
  width: 250px;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px 32px;
`;

const Label_0004 = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 110%;
  text-align: left;
`;

const Section = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: linear-gradient(90deg, rgb(136, 203, 234), rgb(95, 95, 196));
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 60px;
  flex-shrink: 0;
`;

const Wrapper_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 1200px;
  box-sizing: border-box;
`;

const FooterLinks = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 1200px;
  box-sizing: border-box;
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 32px;
  width: 588px;
  box-sizing: border-box;
  padding-right: 16px;
`;

const Frame37 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Logo_0001 = styled.div`
  width: 232px;
  height: 34px;
  position: relative;
`;

const Logo1_0001 = styled.div`
  overflow: hidden;
  position: absolute;
  left: 0px;
  top: 0px;
  right: -1px;
  bottom: 0px;
`;

const Vector_0009 = styled.svg`
  width: 23px;
  height: 28px;
  position: absolute;
  left: 47px;
  top: 3px;
  right: 163px;
  bottom: 3px;
`;

const Vector_0010 = styled.svg`
  width: 23px;
  height: 22px;
  position: absolute;
  left: 73px;
  top: 9px;
  right: 137px;
  bottom: 3px;
`;

const Vector_0011 = styled.svg`
  width: 23px;
  height: 22px;
  position: absolute;
  left: 99px;
  top: 9px;
  right: 111px;
  bottom: 3px;
`;

const Vector_0012 = styled.svg`
  width: 14px;
  height: 22px;
  position: absolute;
  left: 127px;
  top: 9px;
  right: 92px;
  bottom: 3px;
`;

const Vector_0013 = styled.svg`
  width: 15px;
  height: 28px;
  position: absolute;
  left: 142px;
  top: 3px;
  right: 76px;
  bottom: 3px;
`;

const Vector_0014 = styled.svg`
  width: 21px;
  height: 22px;
  position: absolute;
  left: 160px;
  top: 9px;
  right: 52px;
  bottom: 3px;
`;

const Vector_0015 = styled.svg`
  width: 22px;
  height: 22px;
  position: absolute;
  left: 184px;
  top: 9px;
  right: 27px;
  bottom: 3px;
`;

const Vector_0016 = styled.svg`
  width: 14px;
  height: 22px;
  position: absolute;
  left: 210px;
  top: 9px;
  right: 10px;
  bottom: 3px;
`;

const Vector_0017 = styled.svg`
  width: 6px;
  height: 6px;
  position: absolute;
  left: 226px;
  top: 9px;
  right: 1px;
  bottom: 19px;
`;

const Vector_0018 = styled.svg`
  width: 33px;
  height: 20px;
  position: absolute;
  left: 1px;
  top: 14px;
  right: 199px;
  bottom: 0px;
`;

const Vector_0019 = styled.svg`
  width: 10px;
  height: 10px;
  position: absolute;
  left: 13px;
  top: 0px;
  right: 210px;
  bottom: 24px;
`;

const Vector_0020 = styled.svg`
  width: 35px;
  height: 23px;
  position: absolute;
  left: 0px;
  top: 1px;
  right: 198px;
  bottom: 10px;
`;

const PaartnerLimitedRegisteredInEnglandNo16078386 = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
`;

const VatRegistration3700001111 = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
`;

const RegisteredOfficeUnit15RunwellHallFarmhouseHoeLaneRettendonEssexEnglandCm38Dq = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;
